<div *ngIf="dashboardView!='charts'" class="p-grid" [ngClass]="{'dashboard-charts': visitReportsLoading && dashboardView!=''}">
    <div *ngIf="dashboardView==''" class="p-col-12 p-px-3">
        <div class="card p-grid p-p-0">
            <div class="p-col-9">
                <app-filter [selectedWindow]="selectedWindow" [showCardStyle]="false" [filterByInput]="cols" [filterByInputValue]="filterByInputValue" [selectedFilterGroup]="selectedFilterGroup" [customSeletedDateFilter]="selectedDateFilter"
                    (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)" (onClosePanel)="onClosePanel(selectedWindow)"
                    [showChannelFilter]="showChannelFilter" [channelList]="channelList" [selectedChannel]="selectedChannel" (onChangeChannel)="onChangeChannel($event)"
                    (onApplyFilter)="onApplyFilter(selectedWindow, $event)" (onModifyFilterOptions)="onModifyFilterOptions(selectedWindow, $event)" (onChangeRange)="onChangeRange(selectedWindow, $event)">
                </app-filter>
            </div>
            <div class="p-col-3">
                <span class="p-input-icon-left" style="float: right; margin-left: 5px;">
                    <i class="pi pi-search searchPosition"></i>
                    <input type="text" style="float: right; margin: 2px 5px 0px 0px;" pInputText
                        placeholder="Search..." [formControl]="searchControl" />
                </span>
            </div>
        </div>
    </div>

    <div  *ngIf="(!visitReportsLoading && dashboardView!='') || dashboardView==''" class="p-col-12">
        <div class="card">
            <div class="main-content">
                <div *ngIf="selectedWindow==reportsVisitsNames.avareagefieldvisitbyrep" id="divLeadsReport">
                    <app-table2 [selectedWindow]="selectedWindow" [products]="reportsFlatData" [showHeader]="dashboardView==''" [reportName]="reportName"
                            [reportDate]="averageByRepReportDate" [columns]="cols" [dateFrom]="dateFrom" [dateTo]="dateTo"></app-table2>
                </div>
                <div *ngIf="selectedWindow==reportsVisitsNames.getaccountfieldvisithistorybyrep || selectedWindow==reportsVisitsNames.getleadfieldvisithistorybyrep" id="divLeadsReport">
                    <app-template7 *ngIf="dashboardView==''" [stackedBar]="stackedBarByRep" [reportName]="reportName"
                        [reportDate]="historyByRepReportDate">
                    </app-template7>
                    <app-table2 [selectedWindow]="selectedWindow" [reportName]="reportName" [products]="reportsFlatData"
                    [showHeader]="false" [columns]="cols" [dateFrom]="dateFrom" [dateTo]="dateTo">
                    </app-table2>
                </div>
                <div *ngIf="selectedWindow==reportsVisitsNames.getterritorywiseaccountvisithistoryofrep || selectedWindow==reportsVisitsNames.getterritorywiseleadvisithistoryofrep" id="divLeadsReport">
                    <app-template7 *ngIf="dashboardView==''" [stackedBar]="stackedBarByTerri" [reportName]="reportName"
                        [reportDate]="historyByTerriReportDate"></app-template7>
                    <app-table2 [selectedWindow]="selectedWindow" [reportName]="reportName" [products]="reportsFlatData"
                    [showHeader]="false" [columns]="cols" [dateFrom]="dateFrom" [dateTo]="dateTo">
                    </app-table2>
                </div>
                <div *ngIf="selectedWindow==reportsVisitsNames.getterritorywiseaccountvisithistory || selectedWindow==reportsVisitsNames.getterritorywiseleadvisithistory" id="divLeadsReport">
                    <app-table2 [selectedWindow]="selectedWindow" [products]="reportsFlatData" [showHeader]="dashboardView==''" [reportName]="reportName"
                            [reportDate]="accountVisitReportDate" [columns]="cols" [dateFrom]="dateFrom" [dateTo]="dateTo"></app-table2>
                </div>

            </div>
        </div>
    </div>

    <div *ngIf="visitReportsLoading && dashboardView!=''" class="p-col-12">
        <div class="dashboard-charts p-d-flex">
            <app-block-content-spinner  height="100%" style="width: 100%"></app-block-content-spinner>
        </div>
    </div>
</div>

<app-filter *ngIf="dashboardView!=''" [selectedWindow]="selectedWindow"
    [customSeletedDateFilter]="selectedDateFilter"
    [filterByInput]="cols" [filterByInputValue]="filterByInputValue" [selectedFilterGroup]="selectedFilterGroup" [customSeletedDateFilter]="selectedDateFilter"
    (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)" (onClosePanel)="onClosePanel(selectedWindow)"
    [showChannelFilter]="showChannelFilter" [channelList]="channelList" [selectedChannel]="selectedChannel" (onChangeChannel)="onChangeChannel($event)"
    (onApplyFilter)="onApplyFilter(selectedWindow, $event)"
    (onModifyFilterOptions)="onModifyFilterOptions(selectedWindow, $event)"
    (onChangeRange)="onChangeRange(selectedWindow, $event)"
    [filterPopupOnly]="true" [displayFilterPopup]="displayFilterPopup"
    (onCloseFilterPopup)="closeFilterPopup()"
    (onAllFilterApply)="allFiltersChanges($event)">
</app-filter>

<div *ngIf="dashboardView=='charts'" class="dashboard-charts p-d-flex">
    <ng-container *ngIf="!visitReportsLoading" [ngSwitch]="selectedWindow">
        <ng-container *ngSwitchCase="reportsVisitsNames.getaccountfieldvisithistorybyrep">
                <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
                <div style="flex-grow:1; width:100%">
                    <p-chart type="bar" height="100%" [data]="stackedBarByRep" [options]="stackedOptions"></p-chart>
                </div>
        </ng-container>
        <ng-container *ngSwitchCase="reportsVisitsNames.getleadfieldvisithistorybyrep">
            <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
            <div style="flex-grow:1; width:100%">
                <p-chart type="bar" height="100%" [data]="stackedBarByRep" [options]="stackedOptions"></p-chart>
            </div>
    </ng-container>
        <ng-container *ngSwitchCase="reportsVisitsNames.getterritorywiseaccountvisithistoryofrep">
            <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
            <div style="flex-grow:1; width:100%">
                <p-chart type="bar" height="100%" [data]="stackedBarByTerri" [options]="stackedOptions"></p-chart>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="reportsVisitsNames.getterritorywiseleadvisithistoryofrep">
            <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
            <div style="flex-grow:1; width:100%">
                <p-chart type="bar" height="100%" [data]="stackedBarByTerri" [options]="stackedOptions"></p-chart>
            </div>
        </ng-container>
    </ng-container>
    <app-block-content-spinner *ngIf="visitReportsLoading" height="100%" style="width: 100%"></app-block-content-spinner>
</div>
